import {
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_MESSAGE,
  UPDATE_AUTH_USER
} from "./types";
import { getErrorMessage, isApiSuccess, logApiError } from "../utils/error-handler";
import { clearSessionData } from "../utils/token-utils";

export const login = (userApi, authRequestDto, callback) => (dispatch) => {
  userApi.auth(authRequestDto, (error, data, response) => {
    if (!isApiSuccess(error, response)) {
      logApiError("Login", error, response);
      
      const message = getErrorMessage(
        error, 
        response, 
        error?.status === 401 || response?.statusCode === 401
          ? "Usuario o contraseña erróneos."
          : "Ha habido un error, inténtelo más tarde."
      );
      
      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      callback && callback(message, null);
    } else {
       const user = {
         id: data.id,
         name: data.name,
         surname: data.surname,
         token: data.token,
         refreshToken: data.refreshToken,
         email: data.email,
         role: data.role,
         role_id: data.role_id,
         validated: data.validated
       };

      // Guardar datos del usuario en localStorage
      localStorage.setItem("user", JSON.stringify(user));
      
      // Guardar fechas de expiración si están disponibles
      // Convertir a ISO string si es un objeto Date
      if (data.tokenExpiresAt) {
        const tokenExpiresAtStr = data.tokenExpiresAt instanceof Date 
          ? data.tokenExpiresAt.toISOString() 
          : data.tokenExpiresAt;
        localStorage.setItem("tokenExpiresAt", tokenExpiresAtStr);
      }
      if (data.refreshTokenExpiresAt) {
        const refreshTokenExpiresAtStr = data.refreshTokenExpiresAt instanceof Date 
          ? data.refreshTokenExpiresAt.toISOString() 
          : data.refreshTokenExpiresAt;
        localStorage.setItem("refreshTokenExpiresAt", refreshTokenExpiresAtStr);
      }

      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user,
          tokenExpiresAt: data.tokenExpiresAt instanceof Date 
            ? data.tokenExpiresAt.toISOString() 
            : data.tokenExpiresAt,
          refreshTokenExpiresAt: data.refreshTokenExpiresAt instanceof Date 
            ? data.refreshTokenExpiresAt.toISOString() 
            : data.refreshTokenExpiresAt
        },
      });
      dispatch({
        type: SET_MESSAGE,
        payload: "",
      });
    }
  });
};

export const logout = (userApi) => (dispatch) => {
  // Limpiar localStorage completamente
  clearSessionData();

  dispatch({
    type: LOGOUT,
  });

  if (userApi) {
    userApi.logout();
  }
};

export const updateAuthUser = (patch) => ({
  type: UPDATE_AUTH_USER,
  payload: patch
});